var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_602_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.025 30.3462C20.3937 30.8638 15.6066 30.8638 10.9753 30.3462C9.23652 30.1518 7.70997 29.2115 6.74442 27.8459L18.7501 15.8403L22.4546 19.5447C22.894 19.9841 23.6063 19.9841 24.0456 19.5447C24.4849 19.1054 24.4849 18.3932 24.0456 17.9538L19.5456 13.4538C19.1062 13.0145 18.394 13.0145 17.9547 13.4538L5.78142 25.6269C5.74782 25.4626 5.72082 25.2957 5.70102 25.1266C5.14722 20.3912 5.14722 15.6074 5.70102 10.872C6.02337 8.11655 8.23572 5.95865 10.9753 5.65235C15.6066 5.13485 20.3937 5.13485 25.025 5.65235C27.7646 5.95865 29.9769 8.11655 30.2992 10.8721C30.8531 15.6074 30.8531 20.3912 30.2992 25.1266C29.9769 27.882 27.7646 30.04 25.025 30.3462Z",
    fill: "#2D9E11"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_602_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3469 10.9747C30.8645 15.6061 30.8645 20.3932 30.3469 25.0244C30.1526 26.7632 29.2122 28.2898 27.8466 29.2553L15.8411 17.2496L19.5455 13.5451C19.9848 13.1058 19.9848 12.3935 19.5455 11.9541C19.1061 11.5148 18.3939 11.5148 17.9546 11.9541L13.4546 16.4542C13.0152 16.8935 13.0152 17.6057 13.4546 18.0451L25.6277 30.2183C25.4633 30.2519 25.2964 30.2789 25.1273 30.2987C20.3919 30.8525 15.6081 30.8525 10.8728 30.2987C8.11728 29.9764 5.95938 27.764 5.65308 25.0244C5.13558 20.3932 5.13558 15.6061 5.65308 10.9747C5.95938 8.23517 8.11728 6.02282 10.8728 5.70054C15.6081 5.1467 20.3919 5.1467 25.1273 5.70054C27.8827 6.02282 30.0407 8.23516 30.3469 10.9747Z",
    fill: "#2D9E11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11,
    width: 15,
    height: 15,
    fill: "#2D9E11"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0454 11.9545C27.4848 12.3938 27.4848 13.1062 27.0454 13.5455L16.5454 24.0454C16.1061 24.4848 15.3939 24.4848 14.9545 24.0454L8.9545 18.0454C8.51517 17.6061 8.51517 16.8939 8.9545 16.4545C9.39384 16.0152 10.1062 16.0152 10.5455 16.4545L15.75 21.6589L25.4545 11.9545C25.8939 11.5152 26.6061 11.5152 27.0454 11.9545Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_602_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(36 36) rotate(-180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_602_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(36) rotate(90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveWeb);
export default __webpack_public_path__ + "static/media/active_web.9a0d693b4d2105bcd9d0f6cf294ba70b.svg";
export { ForwardRef as ReactComponent };